export default __webpack_public_path__ + "static/media/btn-x.5b635527.svg";